import React, { useState } from 'react';
import { Modal } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export const LifeProof = ({
  showModal,
  title,
  setShowModal,
  redirectUrl = '',
  isLoading = false,
  isValidating = false,
  handleAccept,
  verificationDecision,
}) => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(false);

  const handleClickAccept = () => {
    setAccepted((prev) => !prev);
    handleAccept();
  };

  const error = verificationDecision && verificationDecision !== 'PASSED';

  return (
    <Modal
      showModal={showModal}
      subtitle=""
      width="md:w-7/12"
      closeOnClickOutside={false}
      closeOnSuccess={false}
      setShowModal={setShowModal}
      onSuccess={handleClickAccept}
      title={title}
      showButtons={!accepted && !error}
      showCancel={!error}
      isDisabled={redirectUrl === ''}
      acceptText={t(translations.COMMON.I_ACCEPT)}
      isLoading={isLoading}
    >
      {!accepted && !error && (
        <div>
          <p className="mb-2 text-subtitle text-black">
            {t(translations.MODALS.LIFE_PROOF_MESSAGE)}{' '}
            <a
              className="text-primary-300"
              href="https://www.cincel.digital/aviso-de-privacidad/"
              target="_blank"
              rel="noreferrer"
            >
              {t(translations.COMMON.PRIVACY_POLICY)}
            </a>
          </p>
        </div>
      )}
      {error && (
        <div className="text-center">
          <p>La verificación de identidad no fue exitosa.</p>
          <p>
            Puedes hacer un total de tres intentos para verificar tu identidad. <br />
            Si fallas los tres intentos, por favor comunícate con quien te invitó a firmar este documento para que renueve la cantidad de intentos de verificación de identidad.
          </p>
        </div>
      )}

      {accepted && !error && (
        <>
          <iframe
            allowFullScreen
            src={redirectUrl}
            width="100%"
            height="100%"
            allow="camera;autoplay;fullscreen;clipboard-read;clipboard-write;accelerometer;gyroscope;magnetometer"
            style={{
              width: '100%',
              height: 650,
            }}
            frameBorder="0"
          />
          {isValidating && (
            <div className="z-10000 fixed inset-0 flex items-center justify-center overflow-y-auto overflow-x-hidden p-4 outline-none focus:outline-none ">
              <div className="relative mx-auto my-6 flex h-96 w-full flex-col items-center justify-center rounded-lg bg-white p-8 py-24 text-center md:w-6/12">
                <span>
                  {t(translations.MODALS.LIFE_PROOF_VALIDATING)}
                  <br />
                  {t(translations.MODALS.LIFE_PROOF_CLOSING)}
                </span>
                <div
                  className="spinner-border mt-4 h-6 w-6 animate-spin rounded-full border-4"
                  role="status"
                />
              </div>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};
